// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1VB6d","vLegacy":"SelectSecondary_vLegacy__1D-fT","error":"SelectSecondary_error__1LNzY","disabled":"SelectSecondary_disabled__1hTbQ"};